'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const MRT_Localization_IT = {
    actions: 'Azioni',
    and: 'e',
    cancel: 'Cancella',
    changeFilterMode: 'Cambia modalità filtro',
    changeSearchMode: 'Cambia modalita ricerca',
    clearFilter: 'Cancella filtro',
    clearSearch: 'Cancella ricerca',
    clearSort: 'Cancella ordinamento',
    clickToCopy: 'Click per copiare',
    collapse: 'Chiudi',
    collapseAll: 'Chiudi tutto',
    columnActions: 'Azioni colonna',
    copiedToClipboard: 'Copia negli appunti',
    dropToGroupBy: 'Crea gruppo da {column}',
    edit: 'Modifica',
    expand: 'Espandi',
    expandAll: 'Esapndi tutto',
    filterArrIncludes: 'Includi',
    filterArrIncludesAll: 'Includi tutto',
    filterArrIncludesSome: 'Inclusioni',
    filterBetween: 'Tra',
    filterBetweenInclusive: 'Tra inclusioni',
    filterByColumn: 'Filtra da {column}',
    filterContains: 'Contiene',
    filterEmpty: 'Vuoto',
    filterEndsWith: 'Finisce con',
    filterEquals: 'Uguale',
    filterEqualsString: 'Uguale',
    filterFuzzy: 'Sfocato',
    filterGreaterThan: 'Maggiore di',
    filterGreaterThanOrEqualTo: 'Magiorre o uguale a',
    filterInNumberRange: 'Tra',
    filterIncludesString: 'Contiene',
    filterIncludesStringSensitive: 'Contiene',
    filterLessThan: 'Minore di',
    filterLessThanOrEqualTo: 'Minore o uguale a',
    filterMode: 'Modalità filtro: {filterType}',
    filterNotEmpty: 'Non vuoto',
    filterNotEquals: 'Non uguale',
    filterStartsWith: 'Inizia con',
    filterWeakEquals: 'Uguale',
    filteringByColumn: 'Filtrando da {column} - {filterType} {filterValue}',
    goToFirstPage: 'Vai alla prima pagina',
    goToLastPage: "Vai all'ultima pagina",
    goToNextPage: 'Vai alla pagina successiva',
    goToPreviousPage: 'Vai alla pagina precedente',
    grab: 'Prendi',
    groupByColumn: 'Raggruppa da {column}',
    groupedBy: 'Raggruppa da ',
    hideAll: 'Nascondi tutto',
    hideColumn: 'Nasconi la colonna {column}',
    max: 'Massimo',
    min: 'Minimo',
    move: 'Sposta',
    noRecordsToDisplay: 'Nessun record da mostrare',
    noResultsFound: 'Nessun risultato trovato',
    of: 'di',
    or: 'o',
    pinToLeft: 'Blocca a sinistra',
    pinToRight: 'Blocca a destra',
    resetColumnSize: 'Resetta dimensione colonna',
    resetOrder: 'Resetta ordine',
    rowActions: 'Azioni riga',
    rowNumber: '#',
    rowNumbers: 'Righe',
    rowsPerPage: 'Righe per pagina',
    save: 'Salva',
    search: 'Cerca',
    selectedCountOfRowCountRowsSelected: '{selectedCount} di {rowCount} righe selezionate',
    select: 'Seleziona',
    showAll: 'Mostra tutto',
    showAllColumns: 'Mostra tutte le colonne',
    showHideColumns: 'Mostra/Nascondi colonne',
    showHideFilters: 'Mostra/Nascondi filtri',
    showHideSearch: 'Mostra/Nascondi ricerca',
    sortByColumnAsc: 'Ordina da {column} crescente',
    sortByColumnDesc: 'Ordina da {column} decrecente',
    sortedByColumnAsc: 'Ordinato da {column} crescente',
    sortedByColumnDesc: 'Ordinato da {column} decrescente',
    thenBy: ', poi da',
    toggleDensity: 'Cambia densità',
    toggleFullScreen: 'Cambia schermo intero',
    toggleSelectAll: 'Cambia selezione totale',
    toggleSelectRow: 'Cambia selezione riga',
    toggleVisibility: 'Cambia visibilità',
    ungroupByColumn: 'Rimuovi gruppo {column}',
    unpin: 'Sblocca',
    unpinAll: 'Sblocca tutto',
    unsorted: 'Non ordinato',
};

exports.MRT_Localization_IT = MRT_Localization_IT;
//# sourceMappingURL=it.js.map
